<template>
  <div class="floating-input-label">
    <input
      class="floating-input-label__input"
      type="text"
      :id="id ? id : _uid"
      :required="mandatory ? 'required' : null"
      :pattern="pattern"
      :placeholder="label"
      :autocomplete="autocomplete"
      maxlength="255"
      v-model="currentValue"
      @input="handleInput"
      @change="handleChange"
    >
    <label class="floating-input-label__label" :for="id ? id : _uid">{{ label }}</label>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data: () => ({
    currentValue: '',
  }),
  props: {
    label: String,
    id: String,
    mandatory: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: null,
    },
    pattern: String,
    value: String,
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentValue = newVal;
      }
    },
  },
  methods: {
    handleInput() {
      this.$emit('input', this.currentValue);
    },
    handleChange() {
      this.$emit('change', this.currentValue);
    },
  },
  created() {
    this.currentValue = this.value ?? '';
  },
};
</script>
